import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import * as AppPics from 'assets/images';
import '../../../assets/css/reorder_custom.css';
import useReorderPodcastList from 'hooks/API/GET/useReorderPodcastList';
import useReorderPodcast from 'hooks/API/POST/useReorderPodcast';
import { notifier } from 'components/Toaster';
import { useQueryClient } from 'react-query';
import { ReactSortable } from 'react-sortablejs';
import { AppButton } from 'components';

function ReorderPodcast() {
  const history = useHistory();
  const queryClient = useQueryClient();

  const [podcasts, setPodcasts] = useState([]);
  const [previousOrder, setPreviousOrder] = useState([]);

  const {
    data: podcastData,
    isLoading,
    refetch,
  } = useReorderPodcastList({
    enabled: true,
    config: { params: {} },
    queryKey: ['podcast-reorder-podcast'],
  });

  const { mutate: reorderPodcasts, isLoading: isSaving } = useReorderPodcast();

  // Handle initial data loading and refetching
  useEffect(() => {
    console.log('Raw podcast data:', podcastData);

    if (podcastData && Array.isArray(podcastData)) {
      const sortedPodcasts = [...podcastData].sort(
        (a, b) => (a.sortPosition || 0) - (b.sortPosition || 0)
      );
      console.log('Sorted podcasts:', sortedPodcasts);
      setPodcasts(sortedPodcasts);
      setPreviousOrder(sortedPodcasts.map((podcast) => podcast.id));
    }
  }, [podcastData]);

  const handlePodcastReOrder = async (newPodcasts) => {
    if (isSaving) return;

    const reorderPayload = newPodcasts.map((podcast, index) => ({
      id: podcast.id,
      sortPosition: index + 1,
    }));

    console.log('Reorder payload:', reorderPayload);

    reorderPodcasts(reorderPayload, {
      onSuccess: async (res) => {
        console.log('Reorder success:', res);
        notifier.success(res?.data?.message || 'Podcasts reordered successfully');
        await queryClient.invalidateQueries('podcast-reorder-podcast');
        await queryClient.invalidateQueries('podcasts');
        await queryClient.refetchQueries('podcast-reorder-podcast');
        // Update previous order after successful save
        setPreviousOrder(newPodcasts.map((podcast) => podcast.id));
      },
      onError: (err) => {
        console.error('Reorder error:', err);
        notifier.error(err?.response?.data?.message || 'Failed to reorder podcasts');
        // Revert to original order on error
        if (podcastData && Array.isArray(podcastData)) {
          const sortedPodcasts = [...podcastData].sort(
            (a, b) => (a.sortPosition || 0) - (b.sortPosition || 0)
          );
          setPodcasts(sortedPodcasts);
        }
      },
    });
  };

  const handleBackNavigation = () => {
    history.push('/podcast/list');
  };

  // Handle drag end to ensure state is properly updated
  const handleSortEnd = (newState) => {
    console.log('Sort ended, new state:', newState);
    setPodcasts([...newState]);

    // Check if the order actually changed
    const currentOrder = newState.map((podcast) => podcast.id);
    const hasOrderChanged = !currentOrder.every((id, index) => id === previousOrder[index]);

    console.log('Checking changes:', {
      hasOrderChanged,
      currentOrder,
      previousOrder,
    });

    // Only call API if order actually changed
    if (hasOrderChanged) {
      handlePodcastReOrder(newState);
    }
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <AppButton variantClass="btn-back" onClick={handleBackNavigation}>
              <img src={AppPics.BackSvg} alt="Back" />
            </AppButton>
          </li>
          <li className="active">Reorder Podcast</li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Podcast Home', to: '/podcast' },
                { label: 'Podcast', to: '/podcast/list' },
              ]}
              current="Reorder Podcast"
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              <div className="tab__contentMenu mb-4">
                <h2 className="prime-head p-0 boldtitle text-nowrap">Reorder Podcast</h2>
              </div>
              <div className="tab__contentBody mt-4">
                {isLoading ? (
                  <div className="text-center py-5">
                    <p>Loading podcasts...</p>
                  </div>
                ) : podcasts.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted">No podcasts available to reorder.</p>
                  </div>
                ) : (
                  <ReactSortable
                    list={podcasts}
                    setList={handleSortEnd}
                    handle=".podcastGrabHandleID"
                    animation={200}
                    delayOnTouchStart={true}
                    delay={2}
                    disabled={isSaving}
                  >
                    {podcasts.map((podcast) => (
                      <div className="row mt-3" key={podcast.id}>
                        <div className="col-12">
                          <div className="lessonWrap saved lessonWrap--border podcastGrabHandleID category-item">
                            {/* Status badge */}
                            {podcast?.section && (
                              <span className={`category-badge ${podcast?.section}`}>
                                {podcast?.section === 'trending' ? 'Trending' : 'Popular'}
                              </span>
                            )}
                            <div className="lessonWrap__text">
                              <div className="d-flex align-items-center category-content">
                                <div className="category-info flex-grow-1">
                                  <span className="lessonWrap__name d-block">
                                    {podcast.podcastName}
                                  </span>
                                  {/* <small className="text-muted">ID: {podcast.id}</small> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </ReactSortable>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReorderPodcast;
